module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-01.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "linespace"
  }, [_c('span')]), _vm._v(" "), _c('div', {
    staticClass: "boxnotebrown"
  }, [_c('h2', {
    staticClass: "h2c",
    attrs: {
      "id": "frontmatter01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#rfrontmatter01"
    }
  }, [_c('b', [_vm._v("INTRODUCTION")])])])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v(" gate Surrey Books wants to help everyone, but especially kitchen beginners, learn how to explore different kinds of food and cooking. We are proud to introduce the "), _c('i', [_vm._v("101")]), _vm._v(" series, which aims to provide rewarding, successful, and fun cooking experiences for everyone, from novices to more experienced cooks. "), _c('i', [_vm._v("Diabetes Cooking 101: Master Diabetes Cooking with 101 Great Recipes")]), _vm._v(" is one of the first books in this series, and it offers readers not only delicious recipes but also useful information about shopping for equipment, ingredients, kitchen essentials, and seasonings. Getting started with diabetes cooking can be intimidating, but we’ll demystify the process for you. So whether you or someone you love has just recently been diagnosed with diabetes, or if you have been dealing with the disease for some time, "), _c('i', [_vm._v("Diabetes Cooking 101")]), _vm._v(" is a great place to start.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Most of the recipes in the "), _c('i', [_vm._v("101")]), _vm._v(" series books come from a wide range of Agate Surrey authors and editors. Contributors to "), _c('i', [_vm._v("Diabetes Cooking 101")]), _vm._v(" include Sue Spitler, editor of the “1,001” series that includes titles like "), _c('i', [_vm._v("1,001 Delicious Recipes for People with Diabetes")]), _vm._v(" and "), _c('i', [_vm._v("1,001 Delicious Desserts for People with Diabetes,")]), _vm._v(" and Barbara Grunes, author of "), _c('i', [_vm._v("Diabetes Snacks, Treats, and Easy Eats: 130 Recipes You’ll Make Again and Again")]), _vm._v(" and "), _c('i', [_vm._v("Diabetes Snacks, Treats, and Easy Eats for Kids: 130 Recipes for the Foods Kids Really Like to Eat.")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_c('i', [_vm._v("Diabetes Cooking 101")]), _vm._v(" recipes were selected to provide a starting point for anyone beginning their diabetes cooking journey. The collection includes a variety of cuisines (Italian, Mexican, Spanish, Asian, and Greek, to name a few). Most of the recipes are simple, although a handful of them are more advanced; you’ll find that all are easy to follow.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_c('b', [_vm._v("A TASTE OF WHAT YOU’LL FIND IN THIS BOOK")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("This book contains lots of fantastic main-dish options in the Beef, Chicken, and Seafood Entrées chapters. Don’t miss great dinner-party options like Steak au Poivre, Shish Kebabs, Flank "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("Steak on Salad Greens, and Chicken Cordon Bleu, as well as delicious family pleasers like Chicken and Cheese Rellenos and Soft Tacos. Scallops with Asparagus and Crab Cakes will put smiles on everyone’s face, and Halibut with Sour Cream and Poblano Sauce is a big favorite in our house.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0013-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("In the Side Dishes chapter, check out delicious dishes like Mushrooms with Sour Cream, Eggplant and Vegetable Sauté, Broccoli Rabe Sautéed with Garlic, and Asparagus with Lemon-Wine Sauce.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Looking for a delightful bread option to serve with dinner? Try the Roasted Red Pepper Bread or the Cheddar Biscuits! Cheesecake Cupcakes, Biscotti, and Chocolate Chip Cookies are just a few of the tasty, low-sugar, and low-carbohydrate offerings in the Desserts chapter. Need to delight a more sophisticated palate? Look no further than our Strawberry Cream Pie on "), _c('span', {
    attrs: {
      "href": "#/part10chapter03#page_128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 128")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("But before you get started cooking some of these great recipes, make sure you’re up to speed on some diabetes cooking basics, and that your kitchen and pantry are ready to go!")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_c('b', [_vm._v("DIABETES COOKING BASICS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Have you or someone you love been diagnosed with diabetes; prediabetes, a condition that involves blood glucose levels that are higher than normal but not high enough to be considered diabetic level; or metabolic syndrome, a condition in which one’s "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("body does not use insulin effectively? If so, it’s likely that the doctor advised a change in diet. A sensible diet for a diabetic or prediabetic person is low in fat, low in sugar, low in calories, low in carbohydrates, rich in monounsaturated fats, and includes a wide variety of different types of food. That may sound very daunting to you, but this book proves that you can follow all those guidelines and still enjoy delicious foods.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("When planning meals, watch your carbohydrate intake carefully. You should have approximately the same quantity of carbohydrates at each meal (usually no more than 30 to 45 grams per meal). The American Diabetes Association suggests that you focus on portion sizes at each meal, eating small portions of meats or meat substitutes and starchy foods (like whole-grain pasta and breads, brown rice, or sweet potatoes) and large portions of nonstarchy vegetables, such as spinach, green beans, cucumbers, mushrooms, beets, broccoli, cabbage, or cauliflower. In the pages of this book, you’ll find a number of terrific recipes for each of these delicious options.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Of course, it is always critical to follow the guidance of your doctor regarding any specific directions you are given about diet. This book is not meant to supply medical advice or diet guidelines, but instead to give you a general sense of how to prepare meals that follow the basic eating guidelines observed by many people who are coping with diabetes.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_c('b', [_vm._v("KITCHEN EQUIPMENT BASICS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("If you are a new cook, or it’s been a while since you’ve spent time in the kitchen, here is some helpful information that will make it easy to jump into "), _c('i', [_vm._v("Diabetes Cooking 101")]), _vm._v(" recipes. The following is not necessarily diabetes-cooking specific, but if you have the following equipment, you will be prepared to make almost any recipe in this book.")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4b"
  }, [_c('b', [_vm._v("Appliances")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("We’re sure you know this already, but your kitchen should include the following standard set of appliances.")])]), _vm._v(" "), _c('h5', {
    staticClass: "h5b"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('i', [_vm._v("Pretty Much Mandatory")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Refrigerator/freezer (set to about 34°F to 38°F [1°C to 3°C], or as cold as you can get it without freezing vegetables or drinks)")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Freezer (if yours is not frost-free, you’ll periodically need to unplug it to defrost your snow-filled box)")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Stove/oven (make sure to keep the oven very clean, as burnt foods and other odors can affect the taste of your food)")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Microwave (again, make sure it’s clean and ready for use), because it’s great for defrosting")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Blender (and not just for beverages and soups—you can use it in place of a food processor or an immersion blender in some instances)")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Hand mixer (well, you can always stir by hand, but sometimes, the hand mixer is indispensable)")])]), _vm._v(" "), _c('h5', {
    staticClass: "h5b"
  }, [_c('i', [_vm._v("Optional")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Food processor")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Immersion blender")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Stand mixer")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Slow cooker")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-01.jpg"
    }
  })])]), _vm._v(" "), _c('h5', {
    staticClass: "h5b"
  }, [_c('i', [_vm._v("Pots and Pans")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("The following are useful basic equipment for any kitchen.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Stockpot (8 to 10 quarts ["), _c('i', [_vm._v("7.6")]), _vm._v(" to 9.5 L])")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Dutch oven (5 to 6 quarts [4.7 to 5.7 L])")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Pancake griddle")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Large stockpot with lid (6 to 8 quarts [5.7 to 7.6 L])")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Large skillet with lid (10 to 12 inches in diameter [25 to 30 cm])")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Medium skillet with lid (7 to 8 inches in diameter [17.5 to 20 cm])")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Medium or large saucepan with lid (2 or 3 quarts [1.9 to 2.8 L])")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Small saucepan with lid (1 quart [.95 L])")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Glass casserole dish (2 quarts [1.9 L])")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Square cake pan (8 or 9 inches [20 to 22.5 cm])")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Rectangular cake pan (13 by 9 inches [32.5 by 22.5 cm])")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("2 loaf pans (8 inches [20 cm] long)")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Jelly-roll pan")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Muffin pan (12 muffins)")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Pie pan (9 inches in diameter [22.5 cm])")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("2 baking sheets")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-02.jpg"
    }
  })])]), _vm._v(" "), _c('h5', {
    staticClass: "h5b"
  }, [_c('i', [_vm._v("General Utensils")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("These are recommended basics for any kitchen.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Knives: Chef’s knife, serrated knife, and paring knife")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Measuring cups for both dry and liquid measures")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Measuring spoons")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Mixing bowls (two or three, ranging from 1 or 2 quarts to 5 or 6 quarts [.95 or 1.9 L to 4.7 or 5.7 L])")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Wooden spoons, slotted spoon, rubber or silicone spatula, ladle, whisk, tongs, and a large metal “flipper” for hamburgers and similar foods")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Colander")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Cheese grater")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Citrus zester")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Salt and pepper mills")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Kitchen scissors")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Vegetable peeler")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Can opener")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Cooling rack")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Kitchen timer")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Cutting boards—at least two, so you have one for vegetables and cooked foods and one for raw meats")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Pot holders")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Kitchen towels")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0017-01.jpg"
    }
  })])]), _vm._v(" "), _c('h5', {
    staticClass: "h5b"
  }, [_c('i', [_vm._v("Storage and Paper Supplies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Either in a handy drawer or on a shelf, make sure you have all of these items within easy reach.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Plastic or glass storage containers (5 to 10, varying sizes)")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Aluminum foil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Plastic wrap")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Parchment paper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Small baggies")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Large baggies")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Muffin cup liners")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('b', [_vm._v("BASIC INGREDIENTS LIST FOR DIABETES COOKING")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("This section includes the basics that you should have on hand, but this is by no means a comprehensive list for every recipe in this book. If you have these ingredients as a starting point, however, you’ll be in great shape to tackle almost any of the "), _c('i', [_vm._v("Diabetes Cooking 101")]), _vm._v(" recipes!")])]), _vm._v(" "), _c('h5', {
    staticClass: "h5b"
  }, [_c('i', [_vm._v("Seasonings and Flavorings")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Bay leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Cayenne pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Chili powder")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Ground cumin")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Dry mustard")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Garlic powder")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Ground cinnamon")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Ground ginger")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Ground nutmeg")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Red pepper flakes")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Rosemary")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Italian seasoning")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Oregano")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Paprika")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Kosher salt")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Vanilla extract")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("White pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Freshly ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Beef, chicken, and vegetable bouillon cubes or base (just add water to them to make instant stock)")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0018-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0018-02.jpg"
    }
  })])]), _vm._v(" "), _c('h5', {
    staticClass: "h5b"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('i', [_vm._v("Condiments")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Apple cider vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Balsamic vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Honey")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Hot pepper sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Ketchup")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Mustard")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Olive oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Red wine vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Rice vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Soy sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Vegetable oil")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("White wine vinegar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Worcestershire sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "photo"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0019-02.jpg"
    }
  })])]), _vm._v(" "), _c('h5', {
    staticClass: "h5b"
  }, [_c('i', [_vm._v("Baking")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Cornstarch")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Baking powder")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Baking soda")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Margarine")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Vegetable shortening")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Fat-free milk")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Stevia-based sweetener (see "), _c('a', {
    attrs: {
      "href": "#/#photo"
    }
  }, [_vm._v("photo")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Maple syrup")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Molasses")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Equal® for Recipes or Equal® sweetener in individual packets")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Granulated sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Light brown sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Unbleached all-purpose flour")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Unbleached whole wheat flour")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Unbleached white spelt flour")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Fat-free, nondairy whipped topping")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Dutch process cocoa powder")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Fresh large eggs or egg substitute")])]), _vm._v(" "), _c('h5', {
    staticClass: "h5b"
  }, [_c('i', [_vm._v("General")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Brown rice")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Garlic")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Whole wheat pasta")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Onions")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Canned tomatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Lentils")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Raisins")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Tomato sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _vm._v("Beef, chicken, and vegetable broth")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0020-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0020-02.jpg"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('b', [_vm._v("COMMON COOKING TERMS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("You probably are quite familiar with most of these terms. If this is your first time cooking or it’s been a while since you’ve been in the kitchen, here is a quick refresher:")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Brown:")])]), _vm._v(" To cook a meat at a high temperature for a very brief period of time in order to seal in the juices and add lots of flavor. You’ll see this in a lot of this book’s recipes, because it’s a tremendous flavor booster. Browning should take no more than 2 or 3 minutes on each side and is done before thoroughly cooking the meat. It may be tempting to skip this step, but please don’t…it’s really worth the few minutes in terms of the flavor and texture of the meat once your recipe is complete.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Bake:")])]), _vm._v(" To cook food with dry heat, usually in the oven at a specified temperature.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Boil:")])]), _vm._v(" To cook food in boiling water (212°F [100°C]) on the stovetop.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Blanch:")])]), _vm._v(" A technique that involves immersing food in boiling water for a brief period of time and then immediately transferring into an ice bath in order to stop the cooking process. Blanching is an excellent technique for quickly cooking tender vegetables, as it helps them retain their firmness, crispness, and color.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Braise:")])]), _vm._v(" This technique is a combination of browning the surface of meat, which means to cook at a high temperature for a short amount of time, followed by cooking at a lower temperature in a covered pot with liquid for a longer period of time.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Broil:")])]), _vm._v(" To cook over a high heat at a specified distance from the heat source, usually in the oven or in the “broiler” part of the oven.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Deep fry:")])]), _vm._v(" To cook food by immersing it in preheated oil.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Grill:")])]), _vm._v(" To cook over an open flame on a metal framework, grid, or other cooking surface.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Roast:")])]), _vm._v(" To cook meat in an oven in an uncovered dish, usually resulting in a well-browned surface that seals in juices and flavors.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Sauté:")])]), _vm._v(" To cook food over a medium-high or high heat in a skillet or sauté pan in a small amount of oil, water, stock, or other liquid.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Steam:")])]), _vm._v(" To cook food with steam, usually in a steamer rack or basket positioned over (but not immersed in) a pan containing a small amount of water.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Stir-fry:")])]), _vm._v(" To cook over high heat with a small amount of oil; usually requires regular stirring as food is cooking. It can be used for several kinds of dishes and is often associated with Asian fare.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3b"
  }, [_c('b', [_vm._v("GENERAL COOKING TIPS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("No matter what you’re cooking or how many people you’re serving, a few universal rules of the kitchen will make your life easier. The following is a list of our recommendations for the novice cook. These great habits will ensure fewer mistakes, less stress, and ultimately more delicious food.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Read every recipe from beginning to end, at least twice, before you start cooking.")])]), _vm._v(" This will help to ensure that you understand how it should be made and what you need to make it.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Set up your ingredients, pots, pans, and utensils before you begin to prepare the recipes.")])]), _vm._v(" We never start a recipe until we have every ingredient on the counter in front of us. (If possible, we also premeasure all the ingredients and have them ready to add, because there’s nothing worse than accidentally dumping half a box of kosher salt "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("into an almost-finished recipe.) If you know you’ll need a greased pan in step 4, grease it and set it aside before you even get started.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Keep a grocery list and a pen attached to the refrigerator.")])]), _vm._v(" If you go to the grocery store without a specific list of what you need, you’re likely to forget at least a few items.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Clean up as you go.")])]), _vm._v(" If you take the time to clean your dishes as you’re cooking, you’ll find that you will have more space to work in and less to do after the meal is done.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Time the meal.")])]), _vm._v(" It can be complicated to cook multiple recipes at once and make sure that everything ends up finishing at roughly the same time. Make sure you allow for enough time for everything to get done, and for recipes to be cooked simultaneously.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Be careful.")])]), _vm._v(" It sounds silly, but never forget that you’re working with high-temperature appliances and cookware and sharp utensils! Use proper precaution when lifting lids, turning pans, and straining vegetables.")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-bull"
  }, [_c('span', [_c('span', {
    staticClass: "orange"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space1"
  }), _c('b', [_c('span', {
    staticClass: "brown"
  }, [_vm._v("Have fun!")])]), _vm._v(" We hope you enjoy learning how to cook these recipes and sharing them with others.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a677eeae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter01.vue
// module id = 75
// module chunks = 0